import React, { useEffect } from "react";
import Loader from "../../utilities/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowsRotate,
  faCheckToSlot,
  faMagnifyingGlass,
  faPlus,
  faSliders,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../common-components/Button";
import FilterButton from "../../common-components/FilterButton";
import { hideLoader, showLoader } from "../../redux-store/loaderReducer";
import { communication } from "../../services/communication";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { toggleModal } from "../../redux-store/modalReducer";
import ConfirmVoterFilter from "./ConfirmVoterFilter";
import Pagination from "../../common-components/Pagination";

const ConfirmVotersList = () => {
  const loader = useSelector((state) => state.loaderReducer.loaderState);
  const modal = useSelector((state) => state.modalReducer.modal);
  const pageLimit = process.env.REACT_APP_PAGE_LIMIT ?? 20;
  const [pageCount, setPageCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [isPageUpdated, setIsPageUpdated] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [toggleSearchInput, SetToggleSearchInput] = useState(false);
  const [confirmVoterList, setConfirmVoterList] = useState([]);
  const [electionList, setElectionList] = useState([]);
  const [electionId, setElectionId] = useState("");
  const [filterDetail, setFilterDetail] = useState({
    city: "",
    gender: "",
    voterId: "",
    boothName: "",
    pageNo: "",
  });

  const [totalVoters, setTotalVoters] = useState(0);
  //State to handle index numbers of list
  const [page, setPage] = useState();

  const handlePageClick = (e) => {
    if (searchValue) {
      getConfirmVoterListBySearch(
        searchValue,
        currentPage,
        electionId,
        filterDetail?.city,
        filterDetail?.gender,
        filterDetail?.voterId,
        filterDetail?.pageNo,
        filterDetail?.boothName
      );
    } else {
      fetchConfirmVoterList(
        searchValue,
        currentPage,
        electionId,
        filterDetail?.city,
        filterDetail?.gender,
        filterDetail?.voterId,
        filterDetail?.pageNo,
        filterDetail?.boothName
      );
    }
  };

  //get election wist voter list
  const electionWiseVoterList = (electionId) => {
    try {
      if (electionId) {
        fetchConfirmVoterList(
          searchValue,
          currentPage,
          electionId,
          filterDetail.city,
          filterDetail.gender,
          filterDetail.voterId,
          filterDetail.pageNo,
          filterDetail.boothName
        );
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error?.message,
        icon: "error",
      });
    }
  };

  //get confirmVote list by search
  const getConfirmVoterListBySearch = async (searchString, page) => {
    try {
      if (
        searchString ||
        filterDetail.city ||
        filterDetail.gender ||
        filterDetail.voterId ||
        filterDetail.pageNo ||
        filterDetail.boothName
      ) {
        const responseFromServer = await communication.getConfirmVoterList(
          searchString,
          page,
          electionId,
          filterDetail.city,
          filterDetail.gender,
          filterDetail.voterId,
          filterDetail.pageNo,
          filterDetail.boothName
        );
        if (responseFromServer?.data?.status === "SUCCESS") {
          setConfirmVoterList(responseFromServer?.data?.voter);
          setPageCount(responseFromServer?.data?.totalPages);
          setPage(page);
        } else if (responseFromServer?.data?.status === "JWT_INVALID") {
          dispatch(hideLoader());
          Swal.fire({
            text: responseFromServer?.data?.message,
            icon: "warning",
          });
          navigate("/login");
        } else {
          setConfirmVoterList([]);
          setPageCount(0);
        }
        if (searchValue === "") {
          dispatch(toggleModal(""));
        }
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error?.message,
        icon: "error",
      });
    } finally {
      dispatch(toggleModal(""));
    }
  };
  const getDataByFilter = () => {
    fetchConfirmVoterList(
      searchValue,
      currentPage,
      electionId,
      filterDetail?.city,
      filterDetail.gender,
      filterDetail.voterId,
      filterDetail.pageNo,
      filterDetail.boothName
    );
    dispatch(toggleModal(""));
  };

  //Fetch Confirm Voter list on initial load
  const fetchConfirmVoterList = async (
    searchString,
    page,
    electionId,
    city,
    gender,
    voterId,
    pageNo,
    boothName
  ) => {
    try {
      dispatch(showLoader());
      const responseFromServer = await communication.getConfirmVoterList(
        searchString,
        page,
        electionId,
        city,
        gender,
        voterId,
        pageNo,
        boothName
      );
      if (responseFromServer?.data?.status === "SUCCESS") {
        setConfirmVoterList(responseFromServer?.data?.voter);
        setElectionId(responseFromServer?.data?.electionId);
        setPageCount(responseFromServer?.data?.totalPages);
        setTotalVoters(responseFromServer?.data?.totalVoters);
        setPage(page);
        fetchElectionList();
        setSearchValue("");
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        setConfirmVoterList([]);
        setTotalVoters(0);
        dispatch(hideLoader());
        setPageCount(0);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      Swal.fire({
        text: error?.response?.data?.message || error?.message,
        icon: "error",
      });
    }
  };

  //get all election list
  const fetchElectionList = async () => {
    try {
      const responseFromServer = await communication.getAllElectionList();
      if (responseFromServer?.data?.status === "SUCCESS") {
        setElectionList(responseFromServer?.data?.election);
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        setElectionList([]);
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error?.message,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue?.trim() !== "") {
        getConfirmVoterListBySearch(searchValue?.trim(), 1);
      } else {
        fetchConfirmVoterList("", 1);
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchElectionList();
  }, []);

  useEffect(() => {
    handlePageClick();
  }, [isPageUpdated]);

  return (
    <>
      {loader === true ? (
        <Loader />
      ) : (
        <>
          <div className="top_header">
            <div className="title">Confirm Voter List</div>
            <div className="search_wrapper">
              <input
                type="search"
                value={searchValue}
                onChange={(event) => {
                  // getConfirmVoterListBySearch(event.target.value.trim(), 1);
                  setPage(1);
                  setCurrentPage(1);
                  setSearchValue(event.target.value.trim());
                }}
                className="form-control"
                placeholder="search..."
                style={{
                  width: `${toggleSearchInput === false ? "37px" : "250px"}`,
                  borderRadius: `${
                    toggleSearchInput === false ? "50%" : "5px"
                  }`,
                }}
              />
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                onClick={() => {
                  SetToggleSearchInput(!toggleSearchInput);
                  setSearchValue("");
                  toggleSearchInput &&
                    searchValue !== "" &&
                    fetchConfirmVoterList("", 1);
                }}
                style={{
                  left: `${toggleSearchInput === false ? "50" : "90"}%`,
                  padding:"16px"
                }}
              />
            </div>
          </div>

          <section>
            <div className="section_wrapper">
              <div className="section_header_wrapper">
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageCount={pageCount}
                  isPageUpdated={isPageUpdated}
                  setIsPageUpdated={setIsPageUpdated}
                />
                <div className="button_wrapper">
                  <FontAwesomeIcon
                    icon={faArrowsRotate}
                    onClick={() => {
                      fetchConfirmVoterList("", currentPage);
                      setPage(currentPage);
                      // setCurrentPage(1);
                      setSearchValue("");
                      setFilterDetail({});
                    }}
                    className="refresh_icon"
                    title="Refresh"
                  />
                  <select
                    name="election"
                    onChange={(event) => {
                      electionWiseVoterList(event.target.value);
                      setElectionId(event.target.value);
                    }}
                    className="form-select party_select_box"
                  >
                    <option value="">Select Election</option>
                    {electionList?.map((election, index) => {
                      return (
                        <option
                          value={election?._id}
                          selected={electionId === election?._id}
                          key={index}
                        >
                          {election?.name}
                        </option>
                      );
                    })}
                  </select>
                  <div className="beneficial_voters_count">
                    <h6>
                      Confirm Voter <FontAwesomeIcon icon={faCheckToSlot} />
                    </h6>
                    <h6>{totalVoters}</h6>
                  </div>
                  <FilterButton
                    name="Filter"
                    icon={faSliders}
                    onClick={() => dispatch(toggleModal("filter"))}
                  />
                </div>
              </div>
              <div className="table_wrapper">
                <div className="table">
                  <div className="table_header">
                    <div className="serial_number">
                      <h5>Sr. No</h5>
                    </div>
                    <div className="full_name">
                      <h5>Full Name</h5>
                    </div>
                    <div className="city">
                      <h5>Village/City</h5>
                    </div>
                    <div className="voterId">
                      <h5>Voter ID</h5>
                    </div>
                    <div className="gender">
                      <h5>Gender</h5>
                    </div>
                    <div className="booth_name">
                      <h5>Booth Name</h5>
                    </div>

                    <div className="page_number">
                      <h5>Page Number</h5>
                    </div>
                    <div className="mobile_number">
                      <h5>Mobile Number</h5>
                    </div>
                  </div>

                  {confirmVoterList?.length > 0 ? (
                    <>
                      {confirmVoterList?.map((confirmVoter, index) => {
                        return (
                          <div className="table_data" key={index}>
                            <div className="serial_number">
                              <h6>
                                {Number(pageLimit) * (page - 1) + (index + 1)}
                              </h6>
                            </div>
                            <div className="full_name">
                              <h6>{confirmVoter.name}</h6>
                            </div>
                            <div className="city">
                              <h6>{confirmVoter.city}</h6>
                            </div>
                            <div className="voterId">
                              <h6>{confirmVoter.voterId}</h6>
                            </div>
                            <div className="gender">
                              <h6>{confirmVoter.gender}</h6>
                            </div>
                            <div className="booth_name">
                              <h6>{confirmVoter.boothName}</h6>
                            </div>
                            <div className="page_number">
                              <h6>{confirmVoter.pageNo}</h6>
                            </div>
                            <div className="mobile_number">
                              <h6>
                                {[undefined, null, ""].includes(
                                  confirmVoter.mobile
                                )
                                  ? "NA"
                                  : confirmVoter.mobile}
                              </h6>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="data_not_available_wrapper">
                      Voter Not Available
                    </div>
                  )}
                </div>
              </div>
            </div>
            {modal === "filter" && (
              <ConfirmVoterFilter
                filterDetail={filterDetail}
                setFilterDetail={setFilterDetail}
                getDataByFilter={getDataByFilter}
                searchString={searchValue}
                setCurrentPage={setCurrentPage}
              />
            )}
          </section>
        </>
      )}
    </>
  );
};

export default ConfirmVotersList;
